import { render, staticRenderFns } from "./AssignModal.vue?vue&type=template&id=7c187ef9&scoped=true"
import script from "./AssignModal.vue?vue&type=script&lang=js"
export * from "./AssignModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c187ef9",
  null
  
)

export default component.exports